import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import testimonialsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/testimonialsStyle.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

//icons
import Group from "@material-ui/icons/Group";
import Chart from "@material-ui/icons/ShowChart"
import Star from "@material-ui/icons/Star"

//pics


//video player
import ReactPlayer from 'react-player'



class VideoSection extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    
    return (
      <div className="cd-section" {...rest}>
        <div
          style={{ backgroundColor:"#eeeeee", paddingTop:"23px", paddingBottom:"34px" }}
        >
          <div className={classes.container}>
            <GridContainer>
                <GridItem xs={12} sm={6}>
                    <Card testimonial className={classes.card1}>
                    <CardBody>
                        <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <ReactPlayer url='https://allthingseq.wistia.com/medias/xbm8tet4yv' width='100%' />
                        </GridItem>
                        </GridContainer>
                    </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={false} sm={6}>
                    <GridContainer style={{padding:"20px", marginTop:"34px"}}>

                        <GridItem xs={2} ><Group style={{fontSize: "2.0rem"}} /></GridItem>
                        <GridItem xs={10}>
                            <h4 className={classes.title} style={{marginBottom:"0px", marginTop:"0px"}}>Works With Your Existing Culture</h4>
                            <div className={classes.description} style={{color:"#232323"}}>
                                We bring a shared vocabulary and value system to your existing culture so you don't have to make dramatic changes to use All Things EQ.
                            </div>
                            <br />
                        </GridItem>

                        <GridItem xs={2} ><Chart style={{fontSize: "2.0rem"}} /></GridItem>
                        <GridItem xs={10}>
                            <h4 className={classes.title} style={{marginBottom:"0px", marginTop:"0px"}}>Immediate, Measurable Results</h4>
                            <div className={classes.description} style={{color:"#232323"}}>
                                Simple, layered lessons have immediate real world application and sustainable results.
                            </div>
                            <br />
                        </GridItem>

                        <GridItem xs={2} ><Star style={{fontSize: "2.0rem"}} /></GridItem>
                        <GridItem xs={10}>
                            <h4 className={classes.title} style={{marginBottom:"0px", marginTop:"0px"}}>Leadership Development</h4>
                            <div className={classes.description} style={{color:"#232323"}}>
                            We launch leaders that develop the best in everyone by consistently implementing our EQ model in their school and home.
                            </div>
                            <br />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(testimonialsStyle)(VideoSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionVideo.jsx